import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder, FormGroupDirective } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DriveService } from 'src/app/services/drive/drive.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { CampaignService } from 'src/app/services/campaign/campaign.service';

@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss']
})
export class AttendanceComponent implements OnInit {

  jobApplication: FormGroup;
  email = new FormControl('', [Validators.required, Validators.email]);
  digitExp = '^([1-9])+[0-9]*$';
  nameExp = '[a-zA-Z ]*$';
  currentQualification;
  id: any;
  graduationYear = [];
  qualificationArray = ['BE', 'ME', 'MCA', 'BTECH', 'MTECH', 'MSC', 'Others'];
  currentYear = new Date().getFullYear();
  qualification = new FormControl(null, [Validators.required, Validators.pattern(this.nameExp), this.noWhitespaceValidator]);
  // accessCode = new FormControl(null, [Validators.required, this.noWhitespaceValidator]);
  flag = false;
  AccessCode = new FormControl('', [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/), Validators.minLength(6)]);
  data: any;
  driveShortName: string;
  disableFlag: boolean = true;
  campaignType: any;
  startDate: any;
  emailValue: any;
  getEmail: any;
  date: any;
  constructor(private fb: FormBuilder,
    public route: ActivatedRoute,
    private driveService: DriveService,
    private utilityService: UtilityService,
    private router: Router,
    private campaignService: CampaignService) { }

  ngOnInit() {
    this.driveShortName = this.route.snapshot.paramMap.get('shortName');
    // console.log("shortname fetched: ", this.driveShortName);
    // this.id = this.route.snapshot.params.id;
    this.getCampaignData()


    for (var i = this.currentYear; i >= 2011; i--) {
      this.graduationYear.push(i);
    }
    this.jobApplication = this.fb.group({
      fullName: [null, Validators.compose([Validators.required, Validators.minLength(2),
      Validators.pattern('[a-zA-Z ]*$')])],
      email: [null, Validators.compose([Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/), Validators.maxLength(50)])],
      accessCode: [null, Validators.compose([Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/), Validators.minLength(6)])],
      phoneno: [null, Validators.compose([Validators.required, Validators.pattern('[6-9]{1}[0-9]{9}')])],
      permanantLocation: [null, Validators.compose([Validators.required, Validators.pattern(this.digitExp)])],
      currentLocation: [null, Validators.compose([Validators.required, Validators.pattern(this.digitExp)])],
      currentYear: [null, [Validators.required]],
      currentQualification: [null, [Validators.required]],
      gender: [null, [Validators.required]],
      referralName: [null, [Validators.required, Validators.pattern('[a-zA-Z ]*$')]],
      referralContactNumber: [null, Validators.compose([Validators.required, Validators.pattern('[6-9]{1}[0-9]{9}')])]
    });
  }

  show() {
    this.flag = !this.flag;
  }

  getErrorMessageOfEmail() {

    return this.email.hasError('required') ? 'Email Id Required' : this.email.hasError('email') ? 'Invalid Email Id' : '';
  }

  getErrorMessageOfAccessCode() {
    return this.AccessCode.hasError('required') ? 'Access Code Required' :
      this.AccessCode.hasError('minlength') ? 'Access code must be 6 digits' :
        this.AccessCode.hasError('pattern') ? 'Invalid Access code' :
          '';
  }

  getErrorMessage(controlName: string, alias: string) {

    const control = this.jobApplication.controls[controlName];
    if (control.errors) {
      if (control.errors.required) {
        return alias + ' is required';
      }

      if (control.errors.email) {
        return alias + ' is Invalid';
      }
      if (control.errors.minlength) {
        return alias + ' should have at least ' + control.errors.minlength.requiredLength + ' characters';
      }
      if (control.errors.pattern) {
        return 'Invalid ' + alias.toLowerCase();
      }
      if (control.errors.maxlength) {
        return alias + ' should not have more than ' + control.errors.maxlength.requiredLength + ' characters';
      }
      if (control.errors.min) {
        return alias + ' should be greater than ' + control.errors.min.min;
      }
      if (control.errors.max) {
        return alias + ' can not be greater than ' + control.errors.max.max;
      }


    }
  }

  getErrorForqualification() {
    return this.qualification.hasError('required') ? 'Qualification Cannot be blank' :
      this.qualification.hasError('pattern') ? 'Qualification must contains alphabet only' :
        this.qualification.hasError('whitespace') ? 'Please provide valid full name' :
          '';
  }

  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }


  findUserDetails() {
    
    if (this.email != null  &&  this.email.valid){
      console.log("this.emailvalue data: ", this.emailValue);
      // console.log("focus off");
      let selectedEmail = this.email.value.trim();;
      // console.log("email required: ", selectedEmail);
      let options = {
        purpose: '/users/' + selectedEmail
      }
      if (selectedEmail != '') {
        this.driveService.getWithoutTokens(options).subscribe(
          response => {
            console.log("response after service: ", (response as any).data);
            this.data = (response as any).data;
            if (this.data === "") {
              this.utilityService.openSnackBar("Register to continue");
              this.flag = true;
              
              this.jobApplication.patchValue({
                email: this.email.value
              });
              this.email = null
            } else {
              // this.utilityService.openSnackBar("User already registered");
              this.flag = false;
            }
          },
          error => {
            console.log("error after service call:142 ", error);
            this.utilityService.openSnackBar('Error while retrieving user data');
          }
        )
      }
    }
  }

  getCampaignData() {
    this.campaignService.getCampaignByShortname(this.driveShortName)
      .subscribe(
        response => {
          console.log("response on register page: ", (response as any).data);
          this.campaignType = (response as any).data.campaignType
          // console.log("cmapign type : ", this.campaignType);
          if((response as any).data.eventDate === null){
            this.date = (response as any).data.startDate
          }else{
            this.date = (response as any).data.eventDate
          }
          if (this.campaignType === 'COLLEGE' || this.campaignType === 'INSTITUTE' || this.campaignType === 'HIRING_DRIVE') {
          } else {
            this.router.navigate(['not-found'])
          }
        },
        error => {
          // console.log("error 91--", error);
          this.router.navigate(['not-found'])
        });
  }


  submit(data) {
    if (data != undefined || data != null || data != "") {
      let attendanceData = {
        currentPinCode: data.currentLocation,
        emailId: data.email,
        fullName: data.fullName,
        gender: data.gender,
        permanentPinCode: data.permanantLocation,
        phoneNumber: data.phoneno,
        qualification: data.currentQualification == 'Others' ? this.qualification.value : data.currentQualification,
        graduationYear: data.currentYear
      }
      console.log("data from form: ", attendanceData);
      let options = {
        body: attendanceData,
        purpose: '/drive/attendance/' + this.driveShortName + '/' + data.accessCode
      }
      this.driveService.putWithoutTokens(options).subscribe(
        response => {
          console.log("data after attendence submission: ", response);
          if ((response as any).data.statusCode == -2) {
            this.utilityService.openSnackBar((response as any).data.message);
          } else {
            this.utilityService.openSnackBar((response as any).message);
            // this.jobApplication.reset();
            this.driveService.changeMessage('Your Attendance has been successfully marked...');
            this.router.navigate(['thank-you'])

          }
        },
        error => {
          console.log("error after attendence submission: ", error);
          if (error.error.code === '4000') {
            this.AccessCode.reset();
            this.utilityService.openSnackBar(error.error.detail);
          } else {
            this.utilityService.openSnackBar('Error while marking your attendance');
          }        }
      )
    }
  }

  submitAttendance() {

    let attendanceData = {
      currentPinCode: this.data.currentPinCode,
      emailId: this.data.emailId,
      fullName: this.data.fullName,
      gender: this.data.gender,
      permanentPinCode: this.data.permanentPinCode,
      phoneNumber: this.data.phoneNumber,
      qualification: this.data.qualification,
      graduationYear: this.data.graduationYear.toString(),

      id: this.data.id
    }
    console.log("after submission data: ", attendanceData);
    let options = {
      body: attendanceData,
      purpose: '/drive/attendance/' + this.driveShortName + '/' + this.AccessCode.value
    }
console.log("options: ",this.AccessCode.value );

    this.driveService.putWithoutTokens(options).subscribe(
      response => {
        console.log("data after attendence submission: ", response);
        this.utilityService.openSnackBar((response as any).message);
        this.email.reset();
        this.AccessCode.reset();
        this.driveService.changeMessage('Your Attendance has been successfully marked...');
        this.router.navigate(['thank-you'])
      },
      error => {
        if (error.error.code === '4000') {
          this.AccessCode.reset();
          this.utilityService.openSnackBar(error.error.detail);
        } else {
          this.utilityService.openSnackBar('Error while marking your attendance');
        }
      }
    )
  }

}
